import { COMMON_WAIFUS, getCommonReviews } from '../../../constants.js';

export const ES_BASE = {
    hero: {
      title: "Waifu Briscola",
      tagline: "La Briscola como nunca la has visto: RPG, Waifu e IA.",
      ctaWeb: "Jugar en Web",
      ctaAndroid: "Descargar para Android",
      version: "Versión 2.3",
      badge: "✨ Nuevo Modo Mazmorra"
    },
    stats: {
      downloads: "Descargas",
      downloadsValue: ["¡Incontables!", "Servidores Llenos", "¡Un montón!", "Más de 9000", "Demasiados para contar"],
      hands: "Manos Perdidas",
      handsValue: ["Demasiadas...", "Falta de Skill", "Culpa del Lag", "Todavía lloro", "Intenta de nuevo, tendrás suerte"],
      rating: "Valoración",
      ratingValue: ["Mi abuela aprueba", "11/10 - IGN", "Mejor que la pizza", "GOTY 2026", "Obra Maestra Absoluta"],
      waifus: "Waifu",
      waifusValue: ["Todas para ti", "Solo 2D > 3D", "¡Colecciónalas todas!", "Waifu > Meta", "El verdadero tesoro"]
    },
    features: {
      title: "Mucho más que un juego de cartas",
      items: [
        { id: "classic", title: "Briscola Clásica", description: "La experiencia original, perfecta y limpia.", icon: "🃏" },
        { id: "roguelike", title: "RPG Roguelike", description: "Escala la torre, obtén poderes elementales y derrota a los jefes.", icon: "⚔️" },
        { id: "ai", title: "IA Viviente", description: "Gracias a Google Gemini, las oponentes te insultan o te alaban en tiempo real.", icon: "🧠" },
        { id: "gacha", title: "Sistema Gacha", description: "Usa las monedas para desbloquear nuevas skins y fondos raros.", icon: "💎" },
        { id: "dungeon", title: "Modo Mazmorra", description: "Enfréntate a jefes con reglas locas. Una derrota y se acabó.", icon: "🏰" },
        { id: "puzzle", title: "Modo Puzzle", description: "Resuelve escenarios complejos con objetivos específicos.", icon: "🧩" }
      ]
    },
    video: { title: "Tráiler de Gameplay" },
    waifus: {
      title: "Elige tu Compañera",
      subtitle: "Cada personaje tiene una personalidad única, doblaje y estilo de juego.",
      characters: [
        { ...COMMON_WAIFUS[0], name: "Miu", role: "La Dulce", personality: "Dulce y solar, ama estar cerca de ti." },
        { ...COMMON_WAIFUS[1], name: "Rei", role: "La Analítica", personality: "Calculadora y fría. Solo lógica." },
        { ...COMMON_WAIFUS[2], name: "Akame", role: "La Tsundere", personality: "Competitiva y fogosa. Odia perder." },
        { ...COMMON_WAIFUS[3], name: "Lilith", role: "La Reina", personality: "La oscura reina de las cartas." },
        { ...COMMON_WAIFUS[4], name: "Mochi", role: "La Guía", personality: "Tu guía de confianza... tal vez." }
      ]
    },
    reviews: {
      title: "Dicen de nosotros (desafortunadamente)",
      items: getCommonReviews('es')
    },
    ctaStrip: {
      title: "¿Listo para salir al campo?",
      subtitle: "Únete a otros jugadores y comienza tu aventura hoy.",
      button: "Empieza a Jugar Ahora"
    },
    footer: { privacy: "Privacidad", terms: "Términos", copyright: "© 2026 Waifu Briscola" },
    privacy: {
      title: "Política de Privacidad de Waifu Briscola",
      lastUpdated: "Última actualización: 25 de Mayo de 2024",
      intro: "Esta Política de Privacidad describe cómo se maneja tu información cuando utilizas la aplicación Waifu Briscola ('Servicio').",
      sections: [
        {
          title: "Información que recopilamos",
          intro: "Para mejorar tu experiencia, utilizamos servicios de terceros que pueden recopilar información:",
          items: [
            "Datos de uso (PostHog): Recopilamos datos de análisis anónimos o seudónimos sobre cómo interactúas con el juego. Esto incluye eventos como el inicio de una partida, las cartas jugadas y los resultados finales. Estos datos nos ayudan a entender cómo se utiliza el juego y cómo podemos mejorarlo. No recopilamos información de identificación personal (PII) a través de PostHog.",
            "Interacciones con la IA (Google Gemini): Los mensajes de chat que envías y la información sobre el estado del juego (como las cartas en tu mano y en la mesa) se envían a la API de Google Gemini para generar las respuestas y movimientos de la IA. Estas interacciones están sujetas a la Política de Privacidad de Google. No enviamos ninguna información personal a Google más allá del contenido de tus interacciones de juego.",
          ],
        },
        {
          title: "Cómo usamos tu información",
          intro: "Utilizamos la información recopilada para:",
          items: [
            "Proporcionar, operar y mantener nuestro Servicio.",
            "Mejorar, personalizar y expandir nuestro Servicio.",
            "Entender y analizar cómo usas nuestro Servicio.",
            "Prevenir abusos y garantizar la seguridad.",
          ],
        },
        {
          title: "Compartir información",
          body: "No compartimos tu información personal con nadie, excepto con los proveedores de servicios externos (PostHog, Google) necesarios para el funcionamiento de la aplicación, como se describe anteriormente.",
        },
        {
          title: "Seguridad de los datos",
          body: "La seguridad de tu información es importante para nosotros, pero recuerda que ningún método de transmisión por Internet o método de almacenamiento electrónico es 100% seguro.",
        },
        {
          title: "Cambios a esta Política de Privacidad",
          body: "Podemos actualizar nuestra Política de Privacidad de vez en cuando. Te informaremos de cualquier cambio publicando la nueva Política de Privacidad en esta página.",
        },
        {
          title: "Contáctanos",
          body: "Si tienes preguntas sobre esta Política de Privacidad, puedes contactar al responsable Mauro Mazzocchetti.",
        },
      ],
    },
    consent: { text: "Usamos cookies y analíticas para mejorar el sitio. Al continuar aceptas nuestra", ok: "Entendido" },
    terms: {
      title: "Términos y Condiciones de Waifu Briscola",
      lastUpdated: "Última actualización: 25 de Mayo de 2024",
      contact: "Responsable: Mauro Mazzocchetti",
      intro: "¡Bienvenido a Waifu Briscola! Estos términos y condiciones describen las reglas para el uso de la aplicación Waifu Briscola ('Servicio').",
      sections: [
        {
          title: "Aceptación de los Términos",
          body: "Al acceder y utilizar este Servicio, aceptas estar vinculado por estos Términos. Si no estás de acuerdo con alguna parte de los términos, no puedes utilizar el Servicio.",
        },
        {
          title: "Uso del Servicio",
          body: "Aceptas no utilizar el Servicio para fines ilegales o no autorizados. Eres responsable de tu conducta y de cualquier contenido que proporciones durante el uso del Servicio, incluidos los mensajes de chat.",
        },
        {
          title: "Contenido Generado por IA",
          intro: "El Servicio utiliza modelos de inteligencia artificial (Google Gemini) para generar respuestas, comentarios y movimientos de juego. Reconoces que:",
          items: [
            "El contenido generado por IA es producido por un modelo y puede no ser siempre preciso, apropiado o coherente.",
            "No somos responsables del contenido generado por IA.",
            "Las interacciones con la IA están destinadas únicamente a fines de entretenimiento.",
          ],
        },
        {
          title: "Limitación de Responsabilidad",
          body: "En ningún caso Mauro Mazzocchetti, ni sus socios, serán responsables de ningún daño indirecto, incidental, especial, consecuente o punitivo, incluyendo, sin limitación, la pérdida de beneficios, datos, fondo de comercio u otras pérdidas intangibles, resultantes de (i) tu acceso o uso o incapacidad de acceder o usar el Servicio; (ii) cualquier contenido obtenido del Servicio.",
        },
        {
          title: "Cambios en los Términos",
          body: "Nos reservamos el derecho, a nuestra exclusiva discreción, de modificar o reemplazar estos Términos en cualquier momento. Te informaremos de cualquier cambio publicando los nuevos términos en esta página.",
        },
        {
          title: "Ley Aplicable",
          body: "Estos Términos se regirán e interpretarán de acuerdo con las leyes italianas, sin tener en cuenta sus disposiciones sobre conflictos de leyes.",
        },
      ],
    }
};
